import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import HourPackPopupView from "views/settingsPage/HourPackPopupView";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import StripeHelper from "models/helper/StripeHelper";
import ti18n from "i18n!nls/HourPackPopupi18n";
import RSVP from "rsvp";

const PURCHASE_STATUS = {
    SUCCEEDED: 'succeeded',
    REQUIRES_ACTION: 'requires_action'
};

const HourPackPopupController = Chaplin.Controller.extend({

    initialize: function(options) {
        _.extend(this, Backbone.Events);
        options = options || {};
        this._parentController = options.parentController || null;
        this._workspaceId = options.workspaceId || null;
        this._workspaceUsage = options.workspaceUsage || {};
    },

    getModel: function() {
        return null;
    },

    getView: function() {
        return this.view;
    },

    onPopupClosed: function() {
        // Cleanup handled by view
    },

    handlePurchase: async function(packSize) {
        if (!this._workspaceId) {
            window.alertErrorMessage(window.getI18n(ti18n, "PURCHASE_FAILED"));
            return;
        }

        try {
            var response = await TrebbleClientAPIHelper.getInstance().purchaseHourPack({
                workspaceId: this._workspaceId,
                packSize: packSize
            });

            if (response && response.status === PURCHASE_STATUS.SUCCEEDED) {
                this._handlePurchaseSuccess();
                return;
            }

            if (response && response.status === PURCHASE_STATUS.REQUIRES_ACTION) {
                await this._handleSCAFlow(response.clientSecret);
                return;
            }

            // Unknown response shape — surface a generic failure
            window.alertErrorMessage(window.getI18n(ti18n, "PURCHASE_FAILED"));
        } catch (error) {
            console.error("Purchase hour pack error:", error);
            var message = (error && error.message) ? error.message : window.getI18n(ti18n, "PURCHASE_FAILED");
            window.alertErrorMessage(window.getI18n(ti18n, "PURCHASE_FAILED"), message);
        }
    },

    _handleSCAFlow: async function(clientSecret) {
        if (!clientSecret) {
            window.alertErrorMessage(window.getI18n(ti18n, "PURCHASE_FAILED"));
            return;
        }
        try {
            var stripe = StripeHelper.getInstance().getStripeInstance();
            if (!stripe) {
                window.alertErrorMessage(window.getI18n(ti18n, "PURCHASE_FAILED"));
                return;
            }
            var result = await stripe.confirmCardPayment(clientSecret);
            if (result && result.error) {
                var message = (result.error && result.error.message)
                    ? result.error.message
                    : window.getI18n(ti18n, "PURCHASE_FAILED");
                window.alertErrorMessage(window.getI18n(ti18n, "PURCHASE_FAILED"), message);
                return;
            }
            // SCA succeeded — backend webhook will credit the hours asynchronously.
            // Flag the notification as async so the parent controller knows to
            // schedule a delayed refresh (the immediate one will usually see
            // stale usage because the webhook hasn't landed yet).
            window.alertSuccessMessage(window.getI18n(ti18n, "PROCESSING_HOURS"));
            this._notifyPurchasedAndClose({ isAsync: true });
        } catch (scaError) {
            console.error("Hour pack SCA confirmation error:", scaError);
            var scaMessage = (scaError && scaError.message)
                ? scaError.message
                : window.getI18n(ti18n, "PURCHASE_FAILED");
            window.alertErrorMessage(window.getI18n(ti18n, "PURCHASE_FAILED"), scaMessage);
        }
    },

    _handlePurchaseSuccess: function() {
        window.alertSuccessMessage(window.getI18n(ti18n, "PURCHASE_SUCCESS"));
        this._notifyPurchasedAndClose();
    },

    _notifyPurchasedAndClose: function(options) {
        var isAsync = !!(options && options.isAsync);
        if (this._parentController && typeof this._parentController.trigger === 'function') {
            try {
                this._parentController.trigger('hourPackPurchased', { isAsync: isAsync });
            } catch (eventError) {
                console.warn("Failed to trigger hourPackPurchased event:", eventError);
            }
        }
        if (this.view) {
            this.view.close();
        }
    },

    buildModelAndRenderView: function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                var params = {
                    workspaceUsage: this._workspaceUsage,
                    onPurchase: this.handlePurchase.bind(this),
                    i18nModule: ti18n
                };
                this.view = new HourPackPopupView(params);
                this.listenTo(this.view, "closed", this.onPopupClosed);
                this.view.render();
                resolve();
            } catch (error) {
                reject(error);
            }
        }).bind(this));
    }
});

export default HourPackPopupController;
